// NOTE snake_case used to avoid aliasing a method named in backend code
import { SleepDiaryPayloads } from '@bighealth/types/src/services/SleepDiaryPayloads';
import { DiaryEntry } from '@bighealth/types/src/services/SleepDiaryPayloads/types';

/**
 *
 * @param {DiaryEntry} args
 */
const create_from_weekly_average_estimate = (
  args: DiaryEntry
): SleepDiaryPayloads['create_from_weekly_average_estimate']['request'] => {
  return {
    service_name: 'SleepDiary',
    service_version: '1',
    service_method: 'create_from_weekly_average_estimate',
    args,
  };
};

export { create_from_weekly_average_estimate };
